import styles from "./config.module.scss";
import ThumbNail from "../components/thumbNail/ThumbNail";
import { formatDuration } from "../helpers/generel.helpers";

export const columns = [
  {
    field: "id",
    renderCell: (row) => (
      <ThumbNail
        name={row.title}
        color={row.color}
        hasImage={true}
        imgSrc={`${process.env.REACT_APP_BASE_URL}/media/${row.thumbnail_img}`}
      />
    ),
    className: styles.image,
  },
  {
    field: "title",
    headerName: "Song",
    rowClassName: styles.title,
  },
  {
    field: "artist_name",
    headerName: "Artist Name",
    className: styles.artistname1,
    rowClassName: styles.artistname,
  },

  {
    field: "duration",
    headerName: "Duration",
    renderCell: (row) => formatDuration(row.duration),
    className: styles.likePageFavorite,

    rowClassName: styles.artistname,
  },
];
